import styled from 'styled-components';
import { Checkbox } from '@material-ui/core';
import { useCameraViewContext } from '../../context';
import { useField } from 'react-final-form';
import { useWindowSize } from 'usehooks-ts';
import { useUpdateImage } from 'pages/ListerVehicleUploadV2/hooks/useUpdateImage';
import { CheckedIcon, UnCheckedIcon } from 'components/Icons/CheckboxIcons';

const DamageCheckboxWrapper = styled.div`
  background: ${props => (props.$withBackground ? 'rgba(0, 0, 0, 0.6)' : 'transparent')};

  padding: 4px 16px 4px 10px;
  display: flex;
  gap: 8px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 100%;
  align-items: center;
  color: #fff;
  z-index: 999;

  @media (orientation: landscape) {
    padding: 2px 8px;
    position: static;
    width: fit-content;
  }
`;

type Props = {
  withBackground?: boolean;
};

export const DamageCheckbox: React.FC<Props> = ({ withBackground = true }) => {
  const { imageIndex, level1SectionId, imageLoading } = useCameraViewContext();
  const { input } = useField(`${level1SectionId}.images.${imageIndex}.is_damaged`);
  const { width = 0, height = 0 } = useWindowSize();

  const {
    input: { value: serverId }
  } = useField(`${level1SectionId}.id`);

  const {
    input: { value: imageId }
  } = useField(`${level1SectionId}.images.${imageIndex}.id`);

  const isNewImage = !imageId || imageId.toString() === `${serverId}-${imageIndex}`;

  const updateImage = useUpdateImage(level1SectionId!, imageIndex);

  if (!level1SectionId?.startsWith('exterior') && !level1SectionId?.startsWith('interior')) {
    return null;
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (imageLoading) return;
    input.onChange(e.target.checked);
    if (isNewImage) return;
    updateImage({ is_damaged: e.target.checked });
  };

  return (
    <DamageCheckboxWrapper $withBackground={withBackground}>
      <Checkbox
        disabled={imageLoading}
        checkedIcon={<CheckedIcon />}
        icon={<UnCheckedIcon />}
        style={{
          padding: 0,
          borderRadius: '4px',
          width: 24,
          height: 24
        }}
        inputProps={{
          style: {
            width: width > height ? '24px' : '24px',
            height: width > height ? '24px' : '24px'
          }
        }}
        value={String(!!input.value)}
        checked={input.value}
        onChange={onChange}
      />
      <span>Damage</span>
    </DamageCheckboxWrapper>
  );
};
